import {
  Apple,
  CalendarDays,
  CircleHelp,
  CreditCard,
  Dumbbell,
  Rocket,
  ShieldCheck,
  TrendingUp,
  UserRound,
  Users,
  type LucideIcon,
} from "lucide-react";

import { cn } from "@/lib/utils";
import { HelpCategoryIcon as Icon } from "@complete-athlete/enums";

const ICONS: Record<Icon, LucideIcon> = {
  [Icon.START]: Rocket,
  [Icon.CALENDAR]: CalendarDays,
  [Icon.TRAINING]: Dumbbell,
  [Icon.NUTRITION]: Apple,
  [Icon.PROGRESS]: TrendingUp,
  [Icon.PAYMENTS]: CreditCard,
  [Icon.CLIENTS]: Users,
  [Icon.ACCOUNT]: UserRound,
  [Icon.PRIVACY]: ShieldCheck,
  [Icon.QUESTIONS]: CircleHelp,
};

/** A help category's picture on the soft wash. An icon this build does not know falls back to the question mark. */
export const HelpCategoryIcon = ({ icon, className }: { icon: string; className?: string }) => {
  const Glyph = ICONS[icon as Icon] ?? CircleHelp;
  return (
    <span
      className={cn(
        "grid size-11 shrink-0 place-items-center rounded-2xl bg-[var(--site-wash)] text-[var(--site-ink)]",
        className,
      )}
    >
      <Glyph aria-hidden className="size-5" />
    </span>
  );
};
